import { FC } from 'react';

import { useModifiers } from '@pp/core/src/styles/hooks/useModifiers';
import { L10nText } from '@pp/core/src/services/uiTranslations/reactBindings/L10nText';
import { CurrencyConnected } from '@pp/core/src/components/currency/CurrencyConnected';

import { useHighflyerStateSlice } from '../../../store/slices/highflyerState/selectors';
import { useHighflyerGameStateSlice } from '../../../store/slices/highflyerGame/selectors';

import styles from './MobileCashedAndTotalBets.module.css';

export const MobileCashedAndTotalBets: FC = () => {
	const leaderBoardHistory = useHighflyerGameStateSlice.leaderBoardHistory();
	const mul = useHighflyerStateSlice.getMultiplier();

	const textChangingMods = useModifiers(styles, 'header', {
		cashed: !!mul,
	}, { withBaseClass: true });

	const winAmountMods = useModifiers(styles, 'rightContainer', {
		cashed: !!mul,
	}, { withBaseClass: true });

	return (
		<div className={styles.container}>
			<div className={styles.leftContainer}>
				<div className={textChangingMods}><L10nText tk={mul ? 'CRASH_CASHED_BETS' : 'STATISTICS_TOTAL_BETS'} />:</div>
				{mul &&
					<>
						<div className={textChangingMods}>{leaderBoardHistory?.cashedBetCount || 0}</div>
						<div className={styles.seperator}></div>
					</>
				}
				<div className={styles.betCount}>{leaderBoardHistory?.betCount || 0}</div>
			</div>
			<div className={`${styles.rightContainer} ${winAmountMods}`}>
				<div>
					<CurrencyConnected value={Number(mul ? leaderBoardHistory?.cashedAmount : leaderBoardHistory?.betAmount || 0)} />
				</div>
			</div>
		</div>
	)
}